import { dateToString } from "utils/dateUtils";
import { getAsync as _getAsync, update as _update, add as _add } from "../../api";
import { taskStatuses } from "utils/static/workflowsStaticData";

const BASE_URL = "/flow-tasks";

function normalizeTaskData(data) {
    const { dueDate: dueDateInMillis, startDate: startDateInMillis, endDate: endDateInMillis, status } = data;

    const dueDate = dueDateInMillis && new Date(dueDateInMillis);
    const startDate = startDateInMillis && new Date(startDateInMillis);
    const endDate = endDateInMillis && new Date(endDateInMillis);

    const taskStatus = status && taskStatuses.find((x) => x.value === status);

    return {
        ...data,
        dueDate,
        startDate,
        endDate,
        dueDateString: dateToString(dueDate),
        startDateString: dateToString(startDate),
        endDateString: dateToString(endDate),
        statusString: taskStatus ? taskStatus.label : status,
    };
}

export function normalizeTasks(tasks) {
    return tasks.map((d) => normalizeTaskData(d));
}

export async function getAllAsync({ payload }) {
    const filtersInBase64 = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    return _getAsync({ url: `${BASE_URL}/filtered/${filtersInBase64}`, normalizer: normalizeTasks });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}
